// src/data/contactData.ts
import { ContactDetail } from "../types/ContactDetail";
import { Phone, Mail, MapPin, MessageCircle, Instagram, Facebook } from "lucide-react";

const GOOGLE_MAPS_BASE_URL = 'https://www.google.com/maps?q=';
const ADDRESS = '71-75 Shelton Street, London, WC2H 9JQ, United Kingdom';
const ENCODED_ADDRESS = encodeURIComponent(ADDRESS);

export const contactData: ContactDetail[] = [
  {
    icon: <Phone className="w-6 h-6" />,
    label: 'Phone',
    value: '+44 (20) 79936768',
    link: 'tel:+442079936768',
    iconColorClass: 'text-blue-600',
  },
  {
    icon: <Mail className="w-6 h-6" />,
    label: 'Email Address',
    value: 'info@ssaretailgrouplimited.co.uk', 
    link: 'mailto:info@ssaretailgrouplimited.co.uk',
    iconColorClass: 'text-blue-600',
  },
  {
    icon: <MapPin className="w-6 h-6" />,
    label: 'Address',
    value: ADDRESS, // Use the defined constant
    link: `${GOOGLE_MAPS_BASE_URL}${ENCODED_ADDRESS}`,
    iconColorClass: 'text-blue-600',
  },
  {
    icon: <MessageCircle className="w-6 h-6" />,
    label: 'WhatsApp',
    value: 'Chat with us',
    link: 'https://wa.me/447346608002',
    iconColorClass: 'text-green-500',
  },
  {
    icon: <Instagram className="w-6 h-6" />,
    label: 'Instagram',
    value: '@ssa_retail',
    link: 'https://instagram.com/ssa_retail',
    iconColorClass: 'text-pink-600',
  },
  {
    icon: <Facebook className="w-6 h-6" />,
    label: 'Facebook',
    value: '@ssa_retail',
    link: 'https://facebook.com/share/14Mwamaimg5',
    iconColorClass: 'text-gray-900',
  }
];